import { __decorate } from "tslib";
import { ThemeContribution } from '@alipay/e2-editor-core';
import { singleton } from '@alipay/mana-syringe';
export const WhiteThemeConfig = {
    base: 'vs',
    inherit: true,
    colors: {
        'editor.background': '#F6F7FC',
        'editor.lineHighlightBackground': '#DFDEE2',
        'editorCursor.foreground': '#171717',
        'editor.selectionBackground': '#D2D3D6',
        'editorIndentGuide.background': '#D3D2D6',
        'editorBracketMatch.background': '#D2D3D6',
        'editor.findMatchBackground': '#FFC600',
        'editorWarning.foreground': '#FFAD0A',
        'editorOverviewRuler.warningForeground': '#FFAD0A',
        /** minimap */
        'minimapSlider.activeBackground': '#9FA5B74D',
        'minimapSlider.hoverBackground': '#9FA5B71A',
        /** scrollbar */
        'scrollbarSlider.activeBackground': '#9FA5B799',
        'scrollbarSlider.hoverBackground': '#9FA5B780',
        'scrollbarSlider.background': '#9FA5B766',
        /** diff配置 */
        'diffEditor.removedTextBackground': '#FBD9D966',
        'diffEditor.insertedTextBackground': '#AAE9C366',
    },
    rules: [
        { token: '', foreground: '333333', background: 'ffffff' },
        { token: 'keywords', foreground: '42B1F6' },
        { token: 'customKeywords', foreground: '42B1F6' },
        { token: 'number', foreground: '098658' },
        { token: 'comment', foreground: '258E4F' },
        { token: 'builtinFunctions', foreground: 'A85BEF' },
        { token: 'function', foreground: 'A85BEF' },
        { token: 'operator', foreground: '778899' },
        { token: 'string', foreground: 'E19705' },
        /** JSON */
        { token: 'string.key.json', foreground: '42B1F6' },
        { token: 'string.value.json', foreground: 'E19705' },
        { token: 'number.json', foreground: '098658' },
    ],
};
let WhiteTheme = class WhiteTheme {
    registerItem(registry) {
        registry.registerMonacoTheme(WhiteThemeConfig, 'white');
    }
};
WhiteTheme = __decorate([
    singleton({ contrib: ThemeContribution })
], WhiteTheme);
export { WhiteTheme };
